'use client';

import { useState } from 'react';

interface QuickSearchProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const QuickSearch: React.FC<QuickSearchProps> = ({ searchTerm, setSearchTerm }) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="flex items-center gap-[4px] w-full relative">
      <p className="whitespace-nowrap">Quick Search</p>
      <div className="relative w-full">
        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder="Search..."
          className="w-full pl-[4px] pr-[10px] py-[2px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
        />
        <button
          onClick={() => setSearchTerm('')}
          className="absolute right-[2px] top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-[20px] h-[15px]"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default QuickSearch;
